import React, { Component } from "react";
import _ from "lodash";
import $ from "jquery";
import { Card, CardBody } from "reactstrap";
// import { Switch } from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import DataTable from "../Components/DataTable";
import Documents from "../Components/Documents";
import Loader from "./../../Global/Loader";
import { Button } from "reactstrap";
import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import { Services } from "../../../repositories/clients/Services";
import { withStyles } from "@material-ui/core";
import { Icon } from "semantic-ui-react";
import { Modal, Transfer, Switch } from "antd";
import { moduleActions } from "../../Global/Permission/constants";
import { ShowForRole } from "../../Global/Permission";
import i18n from "../../../i18n";
import { withNamespaces } from "react-i18next";
import { openNotification } from "../Components/Notification";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import TemplateForm from "./Forms/template";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { SetNewListGroups } from "./../../../state/actions/Header/";
import SessionStorage from "./../../../services/SessionStorage";
import Table from "../Components/Table";
const session = new SessionStorage();

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});
const noLinkRole = ["7", "8"];

class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobil: false,
      confirmPassError: false,
      errorPass: false,
      viewpass: false,
      data: {},
      dataDrop: [],
      dataDrop1: [],
      languages: [],
      isEditInfo: false,
      userInfoTmp: {},
      alertsInfo: [],
      entityInfo: {},
      TemplateForm,
      isEdit: false,
      generalInfo: "",
      allActive: false,
      idUsuario: this.props._user ? this.props._user : -1,
      roleId: this.props._rolId ? this.props._rolId : -1,
      showEntity: false,
      loadingInfo: true,
      panelUsuario: true,
      panelUsuarioAsociado: true,
      panelEntityDetail: true,
      panelEntityTable: true,
      panelDocs: true,
      modalOpen: false,
      usersAssociated: [],
      columnsAlertsTable: [
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 50,
          maxWidth: 50,
          custom: (value) => (
            <Switch
              // sx={switchStyle}
              className="form-input-switch"
              disabled={value.checkDisabled}
              checked={value.Activo === 1}
              onChange={this.handleAlertChange(value)}
            ></Switch>
          ),
        },
        {
          label: this.props.t("name"),
          key: "Name",
          minWidth: 170,
          maxWidth: 170,
          showAllText: true,
        },
        {
          label: this.props.t("description"),
          minWidth: 250,
          maxWidth: 250,
          limitString: 200,
          key: "Description",
        },

        {
          label: this.props.t("type"),
          key: "Type",
          minWidth: 100,
          maxWidth: 100,
        },
      ],
      columnsEntityTable: [
        {
          label: "ID",
          key: "EntityId",
          minWidth: 100,
          maxWidth: 100,
          custom: (value) => {
            const { _rolId } = this.props;

            const isNoLinkRole = noLinkRole.includes(_rolId);
            const isRole9Restricted =
              _rolId === "9" && value.from !== "Entities";

            const shouldShowAsLink = !isNoLinkRole && !isRole9Restricted;

            return shouldShowAsLink ? (
              <span
                className="link-euro"
                onClick={() => this.toggleEntity(value.EntityId, value.from)}
              >
                {value.EntityId}
              </span>
            ) : (
              <span>{value.EntityId}</span>
            );
          },
        },
        {
          label: this.props.t("company_name"),
          minWidth: 250,
          maxWidth: 250,
          limitString: 200,
          key: "Nombre",
        },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "CountryCode" },
      ],
      columnsUserTable: [
        {
          label: this.props.t("ID"),
          key: "UserId",
          minWidth: 50,
          maxWidth: 50,
        },
        {
          label: this.props.t("first_name"),
          key: "Name",
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: this.props.t("last_name"),
          key: "LastName",
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: this.props.t("job_role"),
          key: "Role",
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: this.props.t("email"),
          key: "Email",
          minWidth: 150,
          maxWidth: 150,
          showAllText: true,
        },
      ],
      currentPageDataEntity: [],
      currentPageDataUser: [],
      entitiesInfo: [],
      totalRows: 5,
      activeUserPage: 0,
      customWidth: window.innerWidth,
      entitiesFrom: null,
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    const data = this.props.group_list;

    let cout = 0;
    data.map((e) => {
      e.data.map((f) => {
        f.hidden = false;
        if (f.check) {
          cout = cout + 1;
        }
        return f;
      });
      return e;
    });
    this.setState(
      {
        dataDrop: [...data] ? [...data] : [],
        dataDrop1: [...data] ? [...data] : [],
        cout,
        isMobil: isMobileDevice,
      },
      () => {},
    );

    this.setState({ loadingInfo: true });
    await Promise.all([this.getUser(), this.getLanguages()]);
    this.setState({ loadingInfo: false });
    let message = localStorage.getItem("successMessage");
    if (message && message !== "") {
      this.sendMessage(this.props.t(message), "success");
      localStorage.removeItem("successMessage");
    }

    const handleResize = () => {
      this.setState({ customWidth: window.innerWidth });
    };

    window.addEventListener("resize", handleResize);
    document.body.classList.add("transfer-select-all-only");

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  };

  componentWillUnmount() {
    document.body.classList.remove("transfer-select-all-only");
  }

  handleChange = (name, isEditInfo) => (event) => {
    let { userInfo, errorPass, confirmPassError } = this.state;
    userInfo[name] = event.target.value.trimStart();
    if (name === "Telephone") {
      userInfo[name] = event.target.value.replace(/[^0-9]/g, "");
    }
    if (name === "Password" || name === "ConfirmPassword") {
      if (
        (!userInfo["Password"] || userInfo["Password"] === "") &&
        (!userInfo["Password"] || userInfo["Password"] === "")
      ) {
        errorPass = false;
        confirmPassError = false;
      } else {
        //aqui
        const emailRegex = new RegExp(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$%&"#])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/,
        );
        let pass = userInfo["Password"] ? userInfo["Password"] : "";
        if (emailRegex.test(pass)) {
          errorPass = false;
        } else {
          errorPass = true;
        }

        if (userInfo["ConfirmPassword"] !== userInfo["Password"]) {
          confirmPassError = true;
        } else {
          confirmPassError = false;
        }
        if (isEditInfo === true) {
          if (
            userInfo["ConfirmPassword"] === "" &&
            userInfo["Password"] === ""
          ) {
            errorPass = false;
          }
        }
      }
    }

    this.setState({ userInfo, errorPass, confirmPassError }, () =>
      this.generarInfoGeneral("generalInfo"),
    );
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index && value !== null && value !== "";
  };

  handleChangeFilter = (nextTargetKeys, direction, moveKeys) => {
    let { associatedUsersIds } = this.state;
    if (associatedUsersIds) {
      if (direction === "left") {
        moveKeys.forEach((key) => {
          var removeKey = associatedUsersIds.indexOf(key);
          if (removeKey > -1) {
            associatedUsersIds.splice(removeKey, 1);
          }
        });
      } else {
        moveKeys.forEach((key) => {
          associatedUsersIds.push(key);
        });
      }

      associatedUsersIds = associatedUsersIds.filter(this.onlyUnique);
    } else {
      associatedUsersIds = moveKeys;
    }

    this.setState({ associatedUsersIds });
  };

  sendMessage = (text, type) => {
    openNotification(type, text);
  };

  toggleEntity = (entityId, from) => {
    this.setState({ entitiesFrom: from });

    const { entitiesInfo, customerSupplierEntities, supplierEntities } =
      this.state;

    let entityInfo =
      entitiesInfo.find((e) => e.EntityId === entityId) ||
      customerSupplierEntities.find((e) => e.EntityId === entityId) ||
      supplierEntities.find((e) => e.EntityId === entityId);

    if (!entityInfo) {
      console.warn("Entidad no encontrada:", entityId);
      return;
    }

    this.setState({ entityInfo, loadingInfo: true }, () => {
      this.getInfoEntity(entityId);
    });
  };

  editAssociatedUsers = () => {
    this.setState((prevState) => ({
      modalOpen: true,
      initialAssociatedUsersIds: _.cloneDeep(prevState.associatedUsersIds),
      initialAllUsersTransfer: _.cloneDeep(prevState.allUsersTransfer),
    }));
  };

  cancelModal = () => {
    this.setState((prevState) => ({
      modalOpen: false,
      associatedUsersIds: _.cloneDeep(prevState.initialAssociatedUsersIds),
      allUsersTransfer: _.cloneDeep(prevState.initialAllUsersTransfer),
    }));
  };

  updateEntityUser = () => {
    let { associatedUsersIds, entityInfo } = this.state;
    axios
      .put(`${Services.ADMIN.path}perfil/updateEntityUser`, {
        usersAssociated: associatedUsersIds,
        entityId: entityInfo.EntityId,
      })
      .then((response) => {
        this.sendMessage(this.props.t("user_success_updated"), "success");
        this.setState({ loadingInfo: true }, () => {
          this.getInfoEntity(entityInfo.EntityId);
        });
      })
      .catch((ex) => {
        console.log("ex", ex);
        this.sendMessage(this.props.t("update_error"), "error");
      })
      .finally(() => {
        this.setState({ modalOpen: false });
      });
  };

  getInfoEntity = (entityId) => {
    let { entityInfo, totalRows } = this.state;
    axios
      .post(`${Services.ADMIN.path}perfil/getEntityInfo`, {
        rolId: this.props._rolId,
        euroCode: entityInfo.CodeEP,
        entityId,
      })
      .then((response) => {
        this.setState(
          {
            entitySelected: entityId,
            showEntity: true,
            loadingInfo: false,
            activeUserPage: 1,
            documents: response.data.documents,
            usersAssociated: response.data.users.associatedUsers,
            associatedUsersIds: response.data.users.associatedUsersTransfer.map(
              (usr) => {
                return usr.key;
              },
            ),
            allUsersTransfer: response.data.users.allUsersTransfer,
            totalUserPages:
              response.data.users.associatedUsers.length > totalRows
                ? Math.ceil(
                    response.data.users.associatedUsers.length / totalRows,
                  )
                : 1,
          },
          () => {
            this.generarInfoGeneral("generalEntityInfo");
            if (
              this.state.usersAssociated &&
              this.state.usersAssociated.length > 0
            ) {
              this.generatePage(1, "users");
            }
          },
        );
      })
      .catch((ex) => {
        console.log("ex", ex);
      });
  };

  getUser = async () => {
    let { idUsuario } = this.state;
    const { lng } = this.props;

    try {
      const { data } = await axios.post(
        `${Services.ADMIN.path}perfil/getUserInfo`,
        {
          lng,
          userId: idUsuario,
        },
      );

      const {
        userInfo,
        entitiesInfo = [],
        alertsInfo = [],
        supplierEntities = [],
        customerSupplierEntities = [],
      } = data;

      const allActive = alertsInfo.every((alert) => alert.Activo === 1);

      this.setState(
        {
          userInfo,
          userInfoTmp: _.cloneDeep(userInfo),
          entitiesInfo,
          alertsInfo,
          supplierEntities,
          customerSupplierEntities,
          allActive,
        },
        () => {
          this.generarInfoGeneral("generalInfo");
          this.generatePage(1, "entities");
        },
      );
    } catch (error) {
      console.log("🚀 ~ createUsers ~ getUser= ~ error:", error);
    }
  };

  getLanguages = async () => {
    axios
      .get(
        `${Services.ADMIN.path}admin/getLanguages?lang=${this.props.lng}`,
        {},
      )
      .then((response) => {
        this.setState({
          languages: response.data.languages,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  /*
      ####################################GENERACION DE CAMPOS####################################
     */

  cancelEdit = () => {
    let { isEditInfo, userInfoTmp } = this.state;
    let Forms = TemplateForm.editInfo;
    Forms.map((e) => {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.color = "#000a2e";
      }
    });
    this.setState(
      { isEditInfo: !isEditInfo, userInfo: _.cloneDeep(userInfoTmp) },
      () => {
        this.generarInfoGeneral("generalInfo");
      },
    );
  };

  handleChangeDrop = (id) => (evt, data) => {
    let { userInfo } = this.state;
    userInfo[id] = data ? data.value : "";

    this.setState({ userInfo }, () => {
      this.generarInfoGeneral("generalInfo");
    });
  };
  viewPass = (isEdit) => {
    let { viewpass, TemplateForm } = this.state;
    for (
      let i = 0;
      i < TemplateForm[isEdit ? "editInfo" : "previewForm"].length;
      i++
    ) {
      const e = TemplateForm[isEdit ? "editInfo" : "previewForm"][i];
      if (e.id === "ConfirmPassword" || e.id === "Password") {
        e.datatype = viewpass ? "" : "Password";
      }
    }
    this.setState({ TemplateForm }, () => {
      this.generarInfoGeneral("generalInfo");
    });
  };

  handleTelefonoKeyDown = (e) => {
    const key = e.key;
    if (
      /^[0-9]$/.test(key) ||
      [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Delete",
        "Home",
        "End",
      ].includes(key)
    ) {
      return;
    }
    e.preventDefault();
  };

  generarInfoGeneral = (tipo) => {
    let { isEditInfo, userInfo, viewpass, errorPass, confirmPassError } =
      this.state;
    const { classes } = this.props;
    let info =
      tipo === "generalInfo" ? this.state.userInfo : this.state.entityInfo;
    let generalInfo = TemplateForm[
      tipo === "generalEntityInfo"
        ? "entity"
        : tipo === "generalInfo" && isEditInfo
          ? "editInfo"
          : "previewForm"
    ].map((e) => {
      var attrInfo = "";
      var extraClass = "";

      if (e.type === "label") {
        attrInfo = <span className="label-euro">{info[e.id]}</span>;
      } else if (e.type === "lang") {
        attrInfo = (
          <span className="label-euro">
            {this.state.languages
              ? this.state.languages.find((lang) => {
                  return lang.value === userInfo[e.id];
                })?.label
              : null}
          </span>
        );
      } else if (e.type === "empty") {
        attrInfo = (
          <span className="label-euro">
            <input style={{ display: "none" }}></input>
          </span>
        );
      } else if (e.type === "input") {
        attrInfo = (
          <form
            autoComplete={
              e.id === "ConfirmPassword" || e.id === "Password" ? "on" : "off"
            }
            style={{ marginTop: "-7px" }}
          >
            <div style={{ marginTop: "15px" }} key={e.id}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "3px",
                }}
              >
                <TextField
                  // label={e.placeHolder}
                  placeholder={this.props.t(e.placeHolder)}
                  title={this.props.t("fill_field")}
                  variant="standard"
                  type={e.datatype}
                  name={e.id}
                  onKeyDown={(ev) => {
                    if (e.id === "Telephone") {
                      this.handleTelefonoKeyDown(ev);
                    }
                  }}
                  value={userInfo[e.id]}
                  maxlength={e.maxlength}
                  minlength={e.minlength}
                  className={e.id === "Email" ? "email-lower" : ""}
                  InputProps={{
                    classes: {
                      input:
                        e.id === "ConfirmPassword"
                          ? "ajustInput input-euro"
                          : "input-euro",
                    },
                  }}
                  onFocus={(e) => {
                    e.target.setAttribute("autocomplete", "none");
                  }}
                  onChange={this.handleChange(
                    e.id,
                    isEditInfo ? true : false,
                    e.validation,
                  )}
                  max={e.max}
                />

                {e.id === "ConfirmPassword" ? (
                  <span
                    className={
                      viewpass
                        ? "icon-password-see icons-front-module"
                        : "icon-password-unsee icons-front-module"
                    }
                    onClick={() =>
                      this.setState({ viewpass: !viewpass }, () =>
                        this.viewPass(isEditInfo),
                      )
                    }
                    // style={{
                    //   color: "rgb(0, 121, 184)",
                    //   marginLeft: "10px",
                    //   fontSize: "20px",
                    // }}
                    title={this.props.t("show_pass")}
                  ></span>
                ) : (
                  ""
                )}
              </div>
              {errorPass && e.id === "Password" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>
                      {this.props.t("pass_structure")}
                      <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
                        {this.props.t("extended_rule_pass")}
                      </p>
                    </label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                      <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                      <li>At least one uppercase and one lowercase letter.</li>
                                      <li>A special character(*$%&?_-)</li>
                                  </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
              {confirmPassError && e.id === "ConfirmPassword" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>{this.props.t("password_not_match")}</label>
                    {/* <ul style={{ color: '#BA2B30' }}>
                                      <li>Minimun 8 digits and up to maximum 15 digits.</li>
                                      <li>At least one uppercase and one lowercase letter.</li>
                                      <li>A special character(*$%&?_-)</li>
                                  </ul> */}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </form>
        );
      } else if (e.type === "select") {
        attrInfo = (
          <form autoComplete="off">
            <Autocomplete
              closeText={false}
              openText={false}
              disableClearable={true}
              style={{ marginTop: "18px" }}
              className="input-euro"
              size="small"
              ListboxProps={{
                sx: { fontSize: 12 },
              }}
              sx={{
                "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                  fontSize: 12,
                },
              }}
              options={this.state.languages}
              defaultValue={
                this.state.languages
                  ? this.state.languages.find((lang) => {
                      return lang.value === userInfo[e.id];
                    })
                  : null
              }
              value={
                this.state.languages
                  ? this.state.languages.find((lang) => {
                      return lang.value === userInfo[e.id];
                    })
                  : null
              }
              onChange={this.handleChangeDrop(e.id)}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    variant="standard"
                    className={classes.textfield}
                  />
                );
              }}
            />
          </form>
        );
      }
      return (
        <div className={e.class} style={{ paddingTop: "1%" }}>
          {[5, 6].indexOf(parseInt(this.state.roleId)) >= 0 &&
          e.validateRole === true ? (
            ""
          ) : (
            <div className="row">
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                <span
                  id={e.id}
                  className="label-euro"
                  style={{ fontWeight: "bold" }}
                >
                  {this.props.t(e.label)}{" "}
                  {isEditInfo && e.required ? (
                    <span style={{ color: "#ff0000" }}>*</span>
                  ) : (
                    ""
                  )}
                </span>
              </div>
              <div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
                {attrInfo}
              </div>
            </div>
          )}
        </div>
      );
    });
    this.setState({
      [tipo]: generalInfo,
    });
  };
  panelChange = (tipo) => (evt, expanded) => {
    if (tipo === "usuario") {
      if (expanded) {
        $("#row-user-buttons").show();
      } else {
        $("#row-user-buttons").hide();
      }

      this.setState({ panelUsuario: expanded });
    } else if (tipo === "usuarioAsociado") {
      this.setState({ panelUsuarioAsociado: expanded });
    } else if (tipo === "entityTable") {
      this.setState({ panelEntityTable: expanded });
    } else if (tipo === "entityDetail") {
      this.setState({ panelEntityDetail: expanded });
    } else if (tipo === "docs") {
      this.setState({ panelDocs: expanded });
    }
  };

  generatePage = (activePageOrder, tipo) => {
    let { totalRows } = this.state;
    let attrData = "";
    let attrCurrentPage = "";
    if (tipo === "entities") {
      attrData = "entitiesInfo";
      attrCurrentPage = "currentPageDataEntity";
    } else if (tipo === "users") {
      attrData = "usersAssociated";
      attrCurrentPage = "currentPageDataUser";
    }
    let cloneEntity = _.cloneDeep(this.state[attrData]);
    activePageOrder--;
    this.setState({
      [attrCurrentPage]: cloneEntity.slice(
        activePageOrder * totalRows,
        (activePageOrder + 1) * totalRows,
      ),
    });
  };

  returnEdit = () => {
    this.setState(
      { showEntity: false, activeEntityPage: 1, loadingInfo: true },
      () => {
        this.getUser().finally(() => {
          this.setState({ loadingInfo: false });
        });
      },
    );
  };

  handleAllAlertChange = (evt) => {
    console.log("evt", evt);
    let { idUsuario, alertsInfo, allActive, allDisabled } = this.state;
    let data = { alerts: [], userId: idUsuario };
    let checked = evt;
    allActive = evt;
    allDisabled = true;
    if (alertsInfo && alertsInfo.length > 0) {
      for (let i = 0; i < alertsInfo.length; i++) {
        data.alerts.push({
          alertId: alertsInfo[i].AlertNotificationId,
          isChecked: checked,
        });
        alertsInfo[i].checkDisabled = true;
      }
    }

    this.setState({ alertsInfo, allDisabled }, () => {
      axios
        .put(`${Services.ADMIN.path}perfil/UpdateUserAlerts`, data)
        .then((response) => {
          for (let i = 0; i < alertsInfo.length; i++) {
            alertsInfo[i].Activo = checked ? 1 : 0;
          }
        })
        .catch((ex) => {
          console.log("ex", ex);
          this.sendMessage(this.props.t("update_error"), "error");
        })
        .finally(() => {
          for (let i = 0; i < alertsInfo.length; i++) {
            alertsInfo[i].checkDisabled = false;
          }
          this.setState({ alertsInfo, allActive, allDisabled: false });
        });
    });
  };
  handleAlertChange = (alert) => (evt) => {
    let { idUsuario, alertsInfo, allActive } = this.state;
    let checked = evt;
    let data = {
      alerts: [{ alertId: alert.AlertNotificationId, isChecked: checked }],
      userId: idUsuario,
    };
    alertsInfo.map((al) => {
      al.checkDisabled = true;
    });
    this.setState({ alertsInfo, allDisabled: true }, () => {
      axios
        .put(`${Services.ADMIN.path}perfil/UpdateUserAlerts`, data)
        .then((response) => {
          allActive = true;
          alertsInfo.map((al) => {
            if (al.AlertNotificationId === alert.AlertNotificationId) {
              al.Activo = checked ? 1 : 0;
            }
            if (allActive && al.Activo === 0) {
              allActive = false;
            }
          });

          this.setState({ alertsInfo, allActive });
        })
        .catch((ex) => {
          this.sendMessage(this.props.t("update_error"), "error");
        })
        .finally(() => {
          alertsInfo.map((al) => {
            al.checkDisabled = false;
          });
          this.setState({ alertsInfo, allDisabled: false });
        });
    });
  };

  editUserInfo = (e, a) => {
    let { isEditInfo } = this.state;
    this.setState({ isEditInfo: !isEditInfo }, () => {
      this.generarInfoGeneral("generalInfo");
    });
  };

  validarCampos = () => {
    let { userInfo, confirmPassError, errorPass } = this.state;
    let errors = [];
    let validation = [];
    let Forms = TemplateForm.editInfo;

    Forms.map((e) => {
      if (e.required === true) {
        validation.push(e);
      }
      return e;
    });
    validation.forEach((e) => {
      if (!this.state.userInfo[e.id] || this.state.userInfo[e.id] === "") {
        errors.push(this.props.t(e.label));
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "#000a2e";
      }
    });
    if (confirmPassError || errorPass) {
      errors.push("Pass");
      document.getElementById("Password").style.color = "red";
      document.getElementById("ConfirmPassword").style.color = "red";
    } else {
      document.getElementById("Password").style.color = "#000a2e";
      document.getElementById("ConfirmPassword").style.color = "#000a2e";
    }

    return errors.length > 0;
  };

  saveUserInfo = async () => {
    let { userInfo, languages, idUsuario } = this.state;
    let errores = this.validarCampos();
    if (errores) {
      return;
    } else {
      this.setState({ loadingInfo: true });
    }
    let lang = "";
    languages.map((lng) => {
      if (lng.key === userInfo["idSystemLanguages"]) {
        lang = lng.data.Code;
      }
    });

    try {
      let resp = await axios.put(
        `${Services.ADMIN.path}perfil/updateUserInfo`,
        { data: { userInfo, userId: idUsuario } },
      );
      $("#row-user-buttons").hide();
      localStorage.setItem("successMessage", "user_success_updated");

      i18n.changeLanguage(lang);
      let clientes = [];
      let NIT = [];
      this.state.dataDrop.map((e) => {
        e.data.map((f) => {
          if (f.check) {
            clientes.push(f.id);
            NIT.push(f.NIT);
          }
          f.hidden = false;
          return f;
        });
        return e;
      });
      session.updateItem("lang", lang);
      let dataDrop = this.state.dataDrop;
      let notify = this.props.notify;
      this.setState({ lang }, async () => {
        await this.props.SetNewListGroups({
          group_list: dataDrop,
          clients: clientes,
          nit: NIT,
          notify: notify,
          lang: lang,
        });
        window.location.reload(false);
      });
    } catch (error) {
      console.log("ex", error);
    }
  };

  filterOption = (inputValue, item) => {
    const search = inputValue.toLowerCase();

    const label = (item.label || "").toLowerCase();

    return label.includes(search);
  };

  renderEntitiesTables = () => {
    const {
      userInfo,
      entitiesInfo,
      supplierEntities,
      customerSupplierEntities,
      columnsEntityTable,
    } = this.state;

    const { t } = this.props;

    const roleId = userInfo.RoleId;

    const renderTable = (title, data) => (
      <Card
        style={{ padding: "0px 0px 10px 27px" }}
        className="myCard"
        key={title}
      >
        <Accordion elevation={0} defaultExpanded>
          <AccordionSummary
            expandIcon={
              this.state.panelEntityTable ? <ExpandLess /> : <ExpandMore />
            }
          >
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              <span className="euro-title-form">{t(title)}</span>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ width: "100%" }}>
              <Table
                columns={columnsEntityTable}
                data={data}
                itemsByPage={5}
                options={{
                  pagination: true,
                  search: true,
                }}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </Card>
    );

    if (roleId === 9) {
      return (
        <>
          {renderTable("admin_users_associate_suppliers", supplierEntities)}
          {renderTable(
            "admin_users_associate_companies_to_supplier",
            customerSupplierEntities,
          )}
          {renderTable(
            "admin_users_associate_companies_to_customers",
            entitiesInfo,
          )}
        </>
      );
    } else if (roleId === 8) {
      return (
        <>
          {renderTable("admin_users_associate_suppliers", supplierEntities)}
          {renderTable(
            "admin_users_associate_companies_to_supplier",
            customerSupplierEntities,
          )}
        </>
      );
    } else {
      return renderTable("companies", entitiesInfo);
    }
  };

  render() {
    let { loadingInfo, showEntity, isMobil, userInfo, entitiesFrom } =
      this.state;

    return loadingInfo || !userInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-user icon-header" />
          {this.props.t("my_profile")}
          {showEntity ? (
            <div className="euro-return-tittle">
              <Icon.Group size="large">
                <Icon
                  name="angle left"
                  className="_btnBack"
                  size="big"
                  onClick={this.returnEdit}
                />
              </Icon.Group>
              <span className="label-back" onClick={this.returnEdit}>
                {this.props.t("back")}
              </span>
            </div>
          ) : (
            false
          )}
        </div>
        {showEntity ? (
          <div style={{ paddingLeft: "5px" }}>
            <Card style={{ padding: "0px 0px 10px 27px" }} className="myCard">
              <Accordion
                elevation={0}
                defaultExpanded
                onChange={this.panelChange("entityDetail")}
              >
                <AccordionSummary
                  onclic
                  expandIcon={
                    this.state.panelEntityDetail ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  }
                >
                  <div
                    className="row"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <span className="euro-title-form">
                        {this.props.t("company_detail")}
                      </span>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails style={{ marginTop: "-1em" }}>
                  <div style={{ width: "100%" }}>
                    <div className="row">{this.state.generalEntityInfo}</div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
            <ShowForRole
              rol={this.props._rolId}
              moduleAction={moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY}
            >
              {entitiesFrom === "Entities" && (
                <Card
                  style={{ padding: "0px 0px 10px 27px" }}
                  className="myCard"
                >
                  <Accordion
                    elevation={0}
                    defaultExpanded
                    onChange={this.panelChange("docs")}
                  >
                    <AccordionSummary
                      onclic
                      expandIcon={
                        this.state.panelDocs ? <ExpandLess /> : <ExpandMore />
                      }
                    >
                      <div
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <span className="euro-title-form">
                          {this.props.t("documents")}
                        </span>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div style={{ width: "100%" }}>
                        <Documents
                          removeCard={true}
                          dataDoc={this.state.documents}
                          rolId={1}
                          isMobil={isMobil}
                          module={"myProfile"}
                        />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </Card>
              )}
            </ShowForRole>
            <ShowForRole
              rol={this.props._rolId}
              moduleAction={moduleActions.MI_PERFIL_USER_LIST}
            >
              {entitiesFrom === "Entities" && (
                <Card
                  style={{ padding: "0px 0px 10px 27px" }}
                  className="myCard"
                >
                  <Accordion
                    elevation={0}
                    defaultExpanded
                    onChange={this.panelChange("usuarioAsociado")}
                  >
                    <AccordionSummary
                      onclic
                      expandIcon={
                        this.state.panelUsuarioAsociado ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )
                      }
                    >
                      <div
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <span className="euro-title-form">
                          {this.props.t("associated_users")}
                        </span>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="row" style={{ width: "100%" }}>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                          <ShowForRole
                            rol={this.props._rolId}
                            moduleAction={moduleActions.MI_PERFIL_USER_EDIT}
                          >
                            <span
                              className="icon-edit icons-front-module deep float-right"
                              onClick={() => this.editAssociatedUsers()}
                              title={this.props.t("edit")}
                            ></span>
                          </ShowForRole>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                          <Table
                            columns={this.state.columnsUserTable}
                            data={this.state.usersAssociated}
                            itemsByPage={5}
                            options={{
                              pagination: true,
                              search: true,
                            }}
                          />
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </Card>
              )}
            </ShowForRole>
          </div>
        ) : (
          <div>
            <Card style={{ padding: "0px 0px 10px 27px" }} className="myCard">
              <Accordion
                elevation={0}
                defaultExpanded
                onChange={this.panelChange("usuario")}
              >
                <AccordionSummary
                  onclic
                  expandIcon={
                    this.state.panelUsuario ? <ExpandLess /> : <ExpandMore />
                  }
                >
                  <span className="euro-title-form">
                    {this.props.t("user_information")}
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <div id="row-user-buttons" className="row">
                    {this.state.isEditInfo ? (
                      <div className="button-container-profile">
                        <div>
                          <Button
                            block={this.state.customWidth < 768}
                            color="secondary"
                            className="custom-width-btn m-1"
                            onClick={() => this.cancelEdit()}
                          >
                            {this.props.t("cancel")}
                          </Button>
                        </div>
                        <div>
                          <Button
                            block={this.state.customWidth < 768}
                            color="primary"
                            className="custom-width-btn m-1"
                            onClick={() => this.saveUserInfo()}
                          >
                            {this.props.t("confirm")}
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="button-container-profile">
                        <Button
                          block={this.state.customWidth < 768}
                          color="primary"
                          className="custom-width-btn"
                          onClick={() => this.editUserInfo()}
                        >
                          {this.props.t("edit")}
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="row">{this.state.generalInfo}</div>
                </AccordionDetails>
              </Accordion>
            </Card>
            {this.renderEntitiesTables()}
            {[1, 2, 8].indexOf(parseInt(this.state.roleId)) >= 0 ? (
              false
            ) : (
              <Card style={{ padding: "0px 0px 10px 27px" }} className="myCard">
                <Accordion
                  elevation={0}
                  defaultExpanded
                  onChange={this.panelChange("alertsTable")}
                >
                  <AccordionSummary
                    onclic
                    expandIcon={
                      this.state.panelAlertsTable ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    }
                  >
                    <div
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <span className="euro-title-form">
                        {this.props.t("alert_notifications")}
                      </span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      {this.state.alertsInfo &&
                      this.state.alertsInfo.length > 0 ? (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <span className="euro-title-form">
                            {this.state.allActive
                              ? this.props.t("turn_off_all")
                              : this.props.t("turn_on_all")}
                          </span>

                          <Switch
                            className="form-input-switch"
                            style={{ marginLeft: "3px" }}
                            checked={this.state.allActive}
                            disabled={this.state.allDisabled}
                            onChange={this.handleAllAlertChange}
                          ></Switch>
                        </div>
                      ) : (
                        false
                      )}
                      <Table
                        columns={this.state.columnsAlertsTable}
                        data={this.state.alertsInfo}
                        itemsByPage={5}
                        options={{
                          pagination: true,
                          search: false,
                        }}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
              </Card>
            )}
          </div>
        )}

        <Modal
          title=""
          centered
          visible={this.state.modalOpen}
          destroyOnClose
          bodyStyle={{ height: "36 em" }}
          closable={false}
          width={1050}
          footer={null}
        >
          <CardBody>
            <div className="row">
              <div className="col-xs-6 col-md-6 col-lg-6">
                <span className="euro-title-form">
                  {this.props.t("available_users")}
                </span>
              </div>
              <div
                className="col-xs-6 col-md-6 col-lg-6"
                style={{ paddingLeft: "40px" }}
              >
                <span className="euro-title-form">
                  {this.props.t("added_users")}
                </span>
              </div>
              <div className="col-xs-12 col-md-12 col-lg-12">
                <Transfer
                  style={{
                    marginTop: "25px",
                    // width: "100%",
                    // maxWidth: "100%",
                    // justifyContent: "center",
                    // height: "350px",
                  }}
                  locale={{
                    itemUnit: this.props.t("user"),
                    itemsUnit: this.props.t("users"),
                    searchPlaceholder: "",
                    selectAll: this.props.t("select_all_data"),
                    selectCurrent: this.props.t("select_current_page"),
                    selectInvert: this.props.t("invert_current_page"),
                  }}
                  dataSource={this.state.allUsersTransfer}
                  showSearch
                  filterOption={this.filterOption}
                  onChange={this.handleChangeFilter}
                  pagination
                  render={(item) => item.label}
                  targetKeys={this.state.associatedUsersIds}
                  operations={
                    isMobil
                      ? [">", "<"]
                      : [this.props.t("associate"), this.props.t("eliminate")]
                  }
                />
              </div>
            </div>
          </CardBody>

          {!isMobil ? (
            <div className="col-md-12 row">
              <div className="ml-auto">
                <Button
                  color="secondary"
                  className="custom-width-btn m-1"
                  onClick={() => this.cancelModal()}
                >
                  {this.props.t("cancel")}
                </Button>
              </div>
              <div className="mr-auto">
                <Button
                  color="primary"
                  className="custom-width-btn m-1"
                  onClick={() => this.updateEntityUser()}
                >
                  {this.props.t("save")}
                </Button>
              </div>
            </div>
          ) : (
            <div className="row d-flex justify-content-end">
              <div className="col-xs-12 col-md-3 col-lg-3 pb-1">
                <Button
                  block
                  color="secondary"
                  className="button "
                  onClick={() => this.cancelModal()}
                >
                  {this.props.t("cancel")}
                </Button>
              </div>
              <div className="col-xs-12 col-md-3 col-lg-3 pb-1">
                <Button
                  block
                  color="terceareo"
                  className="primary"
                  onClick={() => this.updateEntityUser()}
                >
                  {this.props.t("save")}
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  group_list: state.header.group_list,
  notify: state.header.notify,
  clients: state.header.clients,
  nit: state.header.nit,
  lang: state.header.lang,
});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});
export default withNamespaces()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(useStyles)(withRouter(createUsers))),
);
